export default {
  getCampaign: (state) => (id) => {
    id = parseInt(id);
    if (state.campaigns && id) {
      return state.campaigns.find(p => parseInt(p.id) === id);
    }
    return null;

  },
  offlineDonations: (state) => {
    return state.donations.filter(d => {
      return d.metadata && d.metadata.payment_initiator && d.metadata.payment_initiator.client_email;
    });
  }
}
